import React, { Fragment } from "react"
import { Link } from "react-static"

const CenterHead = () => {
  return(

    <section className="Centerhead">
      <div className="container">
        <div className="row center-xs">
          <div className="col-xs-5">
            <div className="box">
              <h2 className="">Crafting results to communicate your design needs</h2>
            </div>
          </div>
        </div>
    </div>
    </section>
  )

}

export default CenterHead


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Home/components/centerhead.js